import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../../mock";
import Reveal from "../Reveal";

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Testimonials</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
            What Our Clients Are Saying
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-7 md:grid-cols-2">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={(i % 2) * 100}>
              <div className="relative h-full rounded-2xl bg-white p-8 ring-1 ring-slate-100 shadow-sm hover:shadow-xl transition-shadow">
                <Quote className="absolute top-6 right-6 h-10 w-10 text-[#c6a15b]/15" />
                <div className="flex text-[#c6a15b] mb-4">
                  {[...Array(5)].map((_, k) => (
                    <Star key={`${t.name}-star-${k}`} className="h-4 w-4 fill-current" />
                  ))}
                </div>
                <p className="text-slate-700 leading-relaxed">“{t.text}”</p>
                <div className="mt-6 flex items-center gap-4">
                  <div className="h-12 w-12 rounded-full bg-[#0b1f3a] text-[#c6a15b] font-display font-bold flex items-center justify-center">
                    {t.initials}
                  </div>
                  <div>
                    <div className="font-semibold text-[#0b1f3a]">{t.name}</div>
                    <div className="text-sm text-slate-500">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
